import { TimeslotId } from "../timeslots.types";
import createTimeslotId from "./createTimeslotId";

export type Args = {
  dayIndex: number;
  hour: number;
  minute: number;
};

export function calculateTimeslotId({
  dayIndex,
  hour,
  minute,
}: Args): TimeslotId {
  return createTimeslotId(dayIndex * 48 + hour * 2 + (minute === 30 ? 1 : 0));
}

export default calculateTimeslotId;

